import React from 'react'

import { AccountAvatar, Box, styled, UserAvatar } from '@driftt/dds'

import warningIcon from '../../assets/icons/warning.png'

const sharedStyles = { '& img': { objectFit: 'contain' } }
export const AccountActivityUserAvatar = styled(UserAvatar, { ...sharedStyles })
export const BaseAccountAvatar = styled(AccountAvatar, { ...sharedStyles })

export interface AccountAvatarBadgeProps {
  imageUrl?: string
  name?: string
  size?: 'small' | 'medium' | 'large'
  inCrm?: boolean
}

export const AccountActivityAccountAvatar = ({
  imageUrl,
  name,
  size,
  // Default to true for backwards compatibility
  inCrm = true
}: AccountAvatarBadgeProps) => {
  return (
    <Box
      css={{
        position: 'relative',
        display: 'inline-block'
      }}>
      <AccountAvatar imageUrl={imageUrl} name={name} size={size} />
      {!inCrm && (
        <Box
          css={{
            position: 'absolute',
            bottom: 0,
            right: size === 'large' ? '4px' : 0,
            '& img': {
              width: size === 'large' ? '20px' : '15px',
              height: size === 'large' ? '20px' : '15px'
            }
          }}>
          <img src={warningIcon} alt="warning" />
        </Box>
      )}
    </Box>
  )
}
